import { render, staticRenderFns } from "./nutPage.vue?vue&type=template&id=aa5d43a4&scoped=true&"
import script from "./nutPage.vue?vue&type=script&lang=js&"
export * from "./nutPage.vue?vue&type=script&lang=js&"
import style0 from "./nutPage.vue?vue&type=style&index=0&id=aa5d43a4&scoped=true&lang=css&"
import style1 from "./nutPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d43a4",
  null
  
)

export default component.exports